import './popups.scss';
export default (() => {
  document.body.addEventListener('click', function (e) {
    if (e.target.closest('a[href^="#lef-popup-"]')) {
      e.preventDefault();
      var $this = e.target.closest('a[href^="#lef-popup-"]'),
        popup_id = $this.getAttribute('href').replace('#lef-popup-', ''),
        current_popup = document.body.querySelector('[data-popup-id="lef-popup-' + popup_id + '"]');
      if (current_popup) {
        current_popup.classList.add('popup-opened');
      }
    }
    if (e.target.closest('.popup-close')) {
      var $this = e.target.closest('.popup-close'),
        popup = $this.closest('.lef-popup');
      popup.classList.remove('popup-opened');
    }
  });
});